export default __webpack_public_path__ + "static/media/tool-icon-shirt-blue-11.59ff49c9.svg";